import React, { useRef } from 'react';
import { ExperienceStart } from '@atlassian/experience-tracker';
import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import { StyledIframe } from '../iframe';
var getStorageAccessUrl = function getStorageAccessUrl(url, parentProduct, formattedLocale) {
  var CHECK_STORAGE_ACCESS_SUFFIX = "/wiki/embed/storage-access?parentProduct=".concat(parentProduct, "&locale=").concat(formattedLocale);
  return (url ? new URL(url).origin : window.location.origin) + CHECK_STORAGE_ACCESS_SUFFIX;
};
export var StorageAccessPage = function StorageAccessPage(_ref) {
  var contentId = _ref.contentId,
    spaceKey = _ref.spaceKey,
    url = _ref.url,
    parentProduct = _ref.parentProduct,
    formattedLocale = _ref.formattedLocale;
  var iframeRef = useRef(null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExperienceStart, {
    name: ExperienceNames.STORAGE_ACCESS_PAGE,
    id: "".concat(spaceKey, "-").concat(contentId)
  }), /*#__PURE__*/React.createElement(StyledIframe, {
    "data-testid": "storage-access-page-iframe",
    src: getStorageAccessUrl(url, parentProduct, formattedLocale),
    ref: iframeRef
  }));
};